module.exports = __webpack_public_path__ + "static/img/cp_icon_B03.f6970ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_icon_B03.png
// module id = VUgf
// module chunks = 1